var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"bd69139f886d6618250078e7eb34ff49802602c9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["signup@sendgridlabs"]={id:"bd69139f886d6618250078e7eb34ff49802602c9"};
      